export const getFirstSectionId = () => {
  if (typeof window === 'undefined') return '';
  const root = document.querySelector('#root');
  const sections = root.querySelectorAll('section');

  return sections.length > 0 ? sections[0].id : '';
};
